import { z } from "zod";
import { CollectionImportModel, CollectionImportModelInput } from "../collection";
import { AssetImportModelInput, FigmaComponentImportModel, FigmaComponentImportModelInput } from "../component";
import { DataSourceImportModel } from "../data-source";
import { FigmaFileStructureImportModel, FigmaFileStructureImportModelInput } from "../figma-frames";
import { ThemeImportModel, ThemeImportModelInput, ThemeUpdateImportModel, ThemeUpdateImportModelInput } from "../theme";
import { DesignTokenImportModel, DesignTokenImportModelInput } from "../tokens";

//
// Collections
//

export const ImportModelInputCollection = z.object({
  source: DataSourceImportModel,
  tokens: z.array(DesignTokenImportModelInput).default([]),
  components: z.array(FigmaComponentImportModelInput).default([]),
  assets: z.array(AssetImportModelInput).default([]),
  themeUpdates: z.array(ThemeUpdateImportModelInput).default([]),
  themes: z.array(ThemeImportModelInput).default([]),
  figmaFileStructure: FigmaFileStructureImportModelInput.optional(),
  collections: z.array(CollectionImportModelInput),
});

export const ImportModelCollection = z.object({
  sources: z.array(DataSourceImportModel),
  tokens: z.array(DesignTokenImportModel).default([]),
  components: z.array(FigmaComponentImportModel).default([]),
  themeUpdates: z.array(ThemeUpdateImportModel).default([]),
  themes: z.array(ThemeImportModel).default([]),
  figmaFileStructures: z.array(FigmaFileStructureImportModel),
  collections: z.array(CollectionImportModel),
});

export type ImportModelCollection = z.infer<typeof ImportModelCollection>;
export type ImportModelInputCollection = z.infer<typeof ImportModelInputCollection>;

export function addImportModelCollections(
  lhs: ImportModelCollection,
  rhs: ImportModelCollection
): ImportModelCollection {
  return {
    sources: [...lhs.sources, ...rhs.sources],
    tokens: [...lhs.tokens, ...rhs.tokens],
    components: [...lhs.components, ...rhs.components],
    themeUpdates: [...lhs.themeUpdates, ...rhs.themeUpdates],
    themes: [...lhs.themes, ...rhs.themes],
    figmaFileStructures: [...lhs.figmaFileStructures, ...rhs.figmaFileStructures],
    collections: [...lhs.collections, ...rhs.collections],
  };
}
